/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  TerminateOwnTradingChallengeParticipationOptions,
  TerminateOwnTradingChallengeParticipationResponses,
} from '../types/TerminateOwnTradingChallengeParticipation'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Convenience alias that terminates the caller's own participation; redirects to /v1/trading_challenges/{trading_challenge_id}/participants/{user_id}/terminate. End a participant's run in a challenge before its own rules would: the participant leaves, or an operator removes them. No prize is paid, even to a participant who could have claimed one -- claim the prize first if that is what you want. The account is wound down, every remaining challenge credit is swept, and the participation is marked TERMINATED and frozen: from then on it takes no further daily snapshots and never appears in the results ranking again. The user is left deactivated with no challenge balance, and is free to register for another challenge. Participants may only terminate their own run; terminating someone else's requires admin, integrator (same tenant) or challenge manager (assigned challenge) rights.
 * @summary Leave a trading challenge
 * {@link /v1/trading_challenges/:trading_challenge_id/participants/self/terminate}
 */
export function terminateOwnTradingChallengeParticipation<ThrowOnError extends boolean = true>(
  options: Options<TerminateOwnTradingChallengeParticipationOptions, ThrowOnError>,
): Unwrappable<RequestResult<TerminateOwnTradingChallengeParticipationResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/trading_challenges/{trading_challenge_id}/participants/self/terminate',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<TerminateOwnTradingChallengeParticipationResponses, ThrowOnError>>,
  )
}
